function seasonTypes_Reducer(state = [], action) {
    switch (action.type) {
        case 'SEASON_TYPES/SET':
            return action.seasonTypes || state;
        case 'SEASON_TYPES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default seasonTypes_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/seasonTypes.js